import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import './AgentSidebar.css';

// Import icons
import { 
  FaHome, 
  FaClipboardList,
  FaFileInvoice,
  FaCreditCard,
  FaChartBar,
  FaCog,
  FaChevronDown,
  FaChevronUp,
  FaBox,
  FaUserClock
} from 'react-icons/fa';

const AgentSidebar = () => {
  const location = useLocation();
  const { getCurrentUser } = useAuth();
  const currentUser = getCurrentUser();

  // Define sidebar links with appropriate icons
  const sidebarLinks = [
    { path: '/agent/dashboard', label: 'Home', icon: <FaHome size={17} /> },
    { path: '/agent/leads', label: 'Leads', icon: <FaClipboardList size={17} /> },
    { path: '/agent/products', label: 'Products', icon: <FaBox size={17} /> },
    { path: '/agent/invoices', label: 'Invoices', icon: <FaCreditCard size={17} /> },
  ];


  // Additional links after the collapsible section
  const additionalLinks = [
    { path: '/agent/settings', label: 'Settings', icon: <FaCog size={17} /> },
  ];

  return (
    <div className="agent-sidebar">
      <div className="agent-sidebar-logo">
        <img src="/static/images/Wishfin-logo.png" alt="Wishfin" />
      </div>
      
      <div className="agent-sidebar-title">
        <h3>Agent Portal</h3>
      </div>
      
      <nav className="agent-sidebar-nav">
        <ul>
          {/* Main links */}
          {sidebarLinks.map((link) => (
            <li 
              key={link.path} 
              className={location.pathname === link.path ? 'active' : ''}
            >
              <Link to={link.path}>
                <span className="agent-sidebar-icon">{link.icon}</span>
                <span className="agent-sidebar-label">{link.label}</span>
              </Link>
            </li>
          ))}
          
          {/* Additional links */}
          {additionalLinks.map((link) => (
            <li 
              key={link.path} 
              className={location.pathname.startsWith(link.path) ? 'active' : ''}
            >
              <Link to={link.path}>
                <span className="agent-sidebar-icon">{link.icon}</span>
                <span className="agent-sidebar-label">{link.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      
      <div className="agent-sidebar-user-status">
        <div className="agent-sidebar-status">
          <div className="status-indicator online"></div>
          <span>Active</span>
        </div>
      </div>
    </div>
  );
};

export default AgentSidebar;